export enum CallToCustomerDestEnum {
    /**Тех поддержка Лантер */
    lanterSupport = 1,
    /**Склад */
    warehouse = 2,
    /**Тех поддержка банка */
    bankSupport = 3,
}